import { Component, OnInit } from '@angular/core';
import {
  MatDialogConfig,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CustomAuthenticationService } from '@app/auth/services/custom-authentication.service';
import { PermissionsType } from '@app/custom-shared/enums/permissions-type.enum';
import { CriarGruposDeInvestimentoComponent } from '../criar-grupos-de-investimento/criar-grupos-de-investimento.component';
import { EditarGrupoDeInvestimentoComponent } from '../editar-grupo-de-investimento/editar-grupo-de-investimento.component';
import { MasterMasterGroupsComponent } from '../master-groups/master-master-groups.component';
import { MasterMensagemDeletarComponent } from './custom-components/mensagem-deletar/master-mensagem-deletar.component';
import { MasterMensagemDuplicarComponent } from './custom-components/mensagem-duplicar/master-mensagem-duplicar.component';
import { Group } from './master-consulta-grupos-models';
import { MasterConsultaGruposService } from './master-consulta-grupos.service';
import { FeatureService } from '@app/core/services/feature/feature.service';
import {  ConfirmationService  } from 'primeng/api'
import { DialogBoxService } from '@app/custom-shared/components/alerts/dialog-box-service';
import { CustomHomeComponent } from '@app/custom-home/custom-home.component';

@Component({
  selector: 'app-master-consulta-grupos',
  templateUrl: './master-consulta-grupos.component.html',
  styleUrls: ['./master-consulta-grupos.component.scss'],
})
export class MasterConsultaGruposComponent implements OnInit {
  groups: Group[];
  query: any;
  filtredGroups: any;
  groupsComplete: any;
  createPermission = 'Criar grupo de investimento';
  deletePermission = 'Excluir grupo de investimento';
  editPermission = PermissionsType.editarGrupoDeInvestimentos;
  showLoading: boolean = true;
  isOpen = new Array<any>();
  
  constructor(
    private dialogBoxService: DialogBoxService,
    private confirmationService: ConfirmationService,
    private featureService: FeatureService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<MasterConsultaGruposComponent>,
    private _masterGroupsService: MasterConsultaGruposService,
    private router: Router,
    private customAuthenticationService: CustomAuthenticationService,
  ) { }

  ngOnInit() {
    this.getGroups();
  }

  getGroups() {
    this.showLoading=true;
    this._masterGroupsService.getGroups().subscribe(result => {
      if(result){
        this.showLoading=false;
      }
      this.setIsOpen(result.length, -1);
      this.groups = result.sort((a, b) => {
        return a.name.toLowerCase().normalize('NFD').replace(/[^a-zA-Z0-9s]/g, "") >
          b.name.toLowerCase().normalize('NFD').replace(/[^a-zA-Z0-9s]/g, "") ? 1 : -1;
      });
      this.filtredGroups = result;
      if(this.query!=null){
      this.filtredGroups = this.filtredGroups.filter(element => {
        return (
          element.name
            .toLowerCase()
            .indexOf((this.query + '').toLocaleLowerCase()) > -1
        );
      });
      this.filtredGroups = this.groupsComplete;}
     
    });

  }
  openMenu(i) {
    this.setIsOpen(this.isOpen.length, i);
    this.isOpen[i] = !this.isOpen[i];
  }

  setIsOpen(length, index = null) {
    for (var i = 0; i < length; i++) {
      if (i !== index) {
        this.isOpen[i] = false;
      }
    }
  }
  filterGroups(event: Event) {
    this.query = (event.target as HTMLInputElement).value;
    if (this.query.length > 0 && this.query.length % 2 == 0) {
      this.groupsComplete = this.groups.filter(element => {
        return (
          element.name
            .toLowerCase()
            .indexOf((this.query + '').toLocaleLowerCase()) > -1
        );
      });
      this.filtredGroups = this.groupsComplete;
    } else if (this.query.length == 0) {
      this.groupsComplete = [];
      this.filtredGroups = this.groups;
    }
  }
  openDialogConfirmationDelete(group: Group, event) {
   this.doDelete(group,event)


  }
  openDialogConfirmationDuplicate(group: Group, event) {
    this.preventDefault(event);
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.height = '191px';
    dialogConfig.width = '70vw';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.id = 'confirm-box-create-user';
    const dialogRef = this.dialog.open(
      MasterMensagemDuplicarComponent,
      dialogConfig,
    );
    dialogRef.componentInstance.group = group;
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getGroups();
      }
    });
  }

  openDialogCreateGroup() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.height = '90vh';
    dialogConfig.width = '92vw';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.position = { top: '83px' };

    const dialogRef = this.dialog.open(
      CriarGruposDeInvestimentoComponent,
      dialogConfig,
    );
    dialogRef.afterClosed().subscribe(() => {
      this.getGroups();
    });
  }

  openDialogEditGroup(group, event) {
    this.preventDefault(event);
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.height = '90vh';
    dialogConfig.width = '92vw';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.position = {
      top: '83px',
    };

    const dialogRef = this.dialog.open(
      EditarGrupoDeInvestimentoComponent,
      dialogConfig,
    );

    const { id } = group;
    dialogRef.componentInstance.groupId = id;
    dialogRef.afterClosed().subscribe(() => {
      this.getGroups();
    });
  }

  hasPermissions(permissionName: string) {
    return this.customAuthenticationService.hasPermission(permissionName);
  }

  preventDefault(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  goToGroupOfInvestisment(group: Group, event) {
    this.preventDefault(event);
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.height = '90vh';
    dialogConfig.width = '92vw';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.id = 'confirm-box-group-invest';
    const dialogRef = this.dialog.open(
      MasterMasterGroupsComponent,
      dialogConfig,
    );
    dialogRef.componentInstance.name = group.name;
    dialogRef.componentInstance.id = group.id;
  }

  doDelete(group,event) {
    this.preventDefault(event);
    let titlepopup, subtitlepopup, cancelpopup, okpopup: string
    this.featureService.translatorService
      .getMessage('deleteInvestmentGrpTitle')
      .subscribe(val => {
        titlepopup = val
      })
    this.featureService.translatorService
      .getMessage('deleteInvestmentGrpMsg')
      .subscribe(val => {
        subtitlepopup = val
      })
    this.featureService.translatorService
      .getMessage('cancel')
      .subscribe(val => {
        cancelpopup = val
      })
    this.featureService.translatorService
      .getMessage('okDelete')
      .subscribe(val => {
        okpopup = val
      })

    this.dialogBoxService.confirmBox({
      lblTitle: titlepopup,
      lblSubtitle: subtitlepopup,
      lblCancelButton: cancelpopup,
      lblConfirmButton: okpopup,
      color: ' red',
      onConfirm: () => {
        this._masterGroupsService.deleteGroup(group.id)
      .subscribe(data => {
        let successMessage : string
        this.featureService.translatorService
      .getMessage('Investment group deleted successfully')
      .subscribe(val => {
        successMessage = val
      })
        
        setTimeout(() => {
          successMessage.showSuccess()
        }, 3000);
        this.getGroups()
         
          
        
        
      });
      
       // this.dialogRef.close();
      },
    });
  }
}
